import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=fce485ee&scoped=true"
import script from "./productDetails.vue?vue&type=script&lang=js"
export * from "./productDetails.vue?vue&type=script&lang=js"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=fce485ee&prod&lang=less"
import style1 from "./productDetails.vue?vue&type=style&index=1&id=fce485ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce485ee",
  null
  
)

export default component.exports